import {cn} from '../lib/utils';
import type {CanvasData} from './types';

interface Props {
  canvas: CanvasData;
  className?: string;
}

export const CanvasNavbar = ({canvas, className}: Props) => {
  return (
    <div
      className={cn(
        'flex h-16 items-center justify-between bg-(--canvas-primary) gap-4 px-5',
        className,
      )}
    >
      {canvas.organizationLogoUrl ? (
        <img
          src={canvas.organizationLogoUrl}
          alt={canvas.organizationName}
          className="max-h-8 max-w-32 object-contain sm:max-w-48"
        />
      ) : null}
      <div className="ml-auto min-w-0 text-right">
        {canvas.authorName && (
          <div className="text-xs font-normal text-(--canvas-primary-foreground)">
            {canvas.authorName}
          </div>
        )}
        <div
          className={cn(
            'text-xxs font-normal uppercase tracking-wider text-(--canvas-accent)',
            'max-w-64 truncate',
          )}
        >
          {canvas.organizationName}
        </div>
      </div>
    </div>
  );
};
